// src/components/AppointmentTabs.jsx
import React from "react";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";

const AppointmentTabs = ({ selectedTab, onTabChange, patient, hasIpdCapability = true }) => {
  const patientType = patient?.patientType || patient?.patient_type;
  const isOutPatient = patientType === "OUT";
  const isInPatient = patientType === "IN";
  
  const handleTabChange = (event, newValue) => {
    onTabChange(event, newValue);
  };

  return (
    <TabContext value={selectedTab}>
      <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 0 }}>
        <TabList
          onChange={handleTabChange}
          textColor="secondary"
          indicatorColor="secondary"
        >
          {!isInPatient && (
            <Tab label="Appointments" value="appointments" />
          )}
          {hasIpdCapability && !isOutPatient && (
            <Tab label="Admissions" value="admissions" />
          )}
        </TabList>
      </Box>

      {!isInPatient && <TabPanel value="appointments" />}
      {hasIpdCapability && !isOutPatient && <TabPanel value="admissions" />}
    </TabContext>
  );
};

export default AppointmentTabs;